import React from 'react';
import theme from '../theme/theme';
import { Grid } from "@mui/material";
import { Header, SignInUp } from '../components';

function Login() {

  return (
    <div>

      <Header page="Login" />
      <Grid container direction="column" justifyContent="center" alignItems="center" 
      sx={{height: '100vh', backgroundColor: theme.palette.grey[200]}}>
        <SignInUp variant="signin" />
      </Grid>

    </div>
  );
}

export default Login;
